import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { ChecklistItemViewModel } from '../../models/checklists/checklistItemViewModel';
import { ValidatedViewModel } from '../../viewModels/validatedViewModel';
import { ExternalService } from '../../../external/services/external.service';
import { ChecklistItemAbstraction } from './checklist-item.abstraction';

/**
 * Implementation for external users
 * Uses ExternalService endpoints with externalShareId
 */
@Injectable({
  providedIn: 'root',
})
export class ExternalUserChecklistService extends ChecklistItemAbstraction {
  constructor(
    private externalService: ExternalService
  ) {
    super();
  }

  add(checklistItem: ChecklistItemViewModel): Observable<ValidatedViewModel> {
    return throwError(() => new Error('Add operation not supported for external users'));
  }

  update(checklistItem: ChecklistItemViewModel, externalShareId?: string): Observable<ChecklistItemViewModel> {
    if (!externalShareId) {
      return throwError(() => new Error('External share ID not provided for external user'));
    }
    return this.externalService.updateChecklistItem(externalShareId, checklistItem);
  }

  updateItems(checklistItems: ChecklistItemViewModel[], externalShareId?: string): Observable<ChecklistItemViewModel[]> {
    return throwError(() => new Error('Batch update operation not supported for external users'));
  }

  delete(checklistItemId: number): Observable<ChecklistItemViewModel> {
    return throwError(() => new Error('Delete operation not supported for external users'));
  }

  getList(): Observable<ChecklistItemViewModel[]> {
    return of([]);
  }

  getListByGlobalObjectId(globalObjectId: number, globalObjectType: number, externalShareId?: string): Observable<ChecklistItemViewModel[]> {
    if (!externalShareId) {
      console.error('External share ID not provided for external user');
      return of([]);
    }

    return this.externalService.getChecklistItems(
      externalShareId,
      globalObjectId.toString(),
      globalObjectType.toString()
    );
  }

  addFromTemplate(
    checklistTemplateIds: number[],
    globalObjectId: number,
    globalObjectType: number
  ): Observable<ChecklistItemViewModel[]> {
    return throwError(() => new Error('Add from template operation not supported for external users'));
  }
}
